export default __webpack_public_path__ + "e8090065c6ad96333715e5131e416e93.svg";